import { Flex } from '../Flex';
import React from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import Ruler from './Ruler';
import PriceLabel from './PriceLabel';
import PriceTooltip from './PriceTooltip';
import { FullWidthFlex } from './styles';
const MAX_QUARTILE = 3;
const FALLBACK_QUARTILE = 0; // mostra a regua padrão sem quartil
const MeterPriceTooltipProps = [{
  pinposition: 'left',
  tooltipStyle: {
    justifyContent: 'flex-start'
  }
}, {
  pinposition: 'center',
  tooltipStyle: {
    justifyContent: 'center'
  }
}, {
  pinposition: 'right',
  tooltipStyle: {
    justifyContent: 'flex-end'
  }
}];
const PositionedPriceTooltip = _ref => {
  let {
    price,
    quartile,
    percentageFromMedianPrice
  } = _ref;
  const {
    tooltipStyle
  } = MeterPriceTooltipProps[quartile - 1];
  const caption = percentageFromMedianPrice ? "".concat(Math.abs(percentageFromMedianPrice).toFixed(0), "% ").concat(percentageFromMedianPrice >= 0 ? 'abaixo' : 'acima', " da m\xE9dia") : 'Preço do anúncio';
  return React.createElement(Flex, {
    style: tooltipStyle
  }, React.createElement(PriceTooltip, null, React.createElement(PriceLabel, {
    price: price,
    caption: caption
  })));
};
function getRectsWithTooltipByQuartile(quartile, highlightedColors, price, olxPrice, percentageFromMedianPrice) {
  // Create an array with only the desired quartile colored
  const rectColors = Array(highlightedColors.length).fill('var(--color-neutral-90)');
  const quartileIndex = quartile - 1;
  rectColors[quartileIndex] = highlightedColors[quartileIndex];
  return React.createElement(FullWidthFlex, {
    flexDirection: "column"
  }, React.createElement(PositionedPriceTooltip, {
    quartile: quartile,
    price: price,
    percentageFromMedianPrice: percentageFromMedianPrice
  }), React.createElement(Ruler, {
    rectColors: rectColors,
    quartileIndex: quartileIndex,
    adPrice: price,
    olxPrice: olxPrice
  }));
}
export const PriceReferenceRuler = _ref2 => {
  let {
    adPrice,
    percentageFromMedianPrice,
    quartile,
    quartileColors,
    olxPrice,
    hideWithoutPriceInput = false
  } = _ref2;
  const withoutPriceInput = hideWithoutPriceInput ? React.createElement(React.Fragment, null) : React.createElement(Ruler, {
    rectColors: quartileColors['normal'],
    quartileIndex: -1,
    adPrice: adPrice,
    olxPrice: olxPrice
  });
  const isValidQuartile = !!(quartile && quartile >= 1 && quartile <= MAX_QUARTILE);
  const content = adPrice && isValidQuartile && olxPrice ? getRectsWithTooltipByQuartile(quartile || FALLBACK_QUARTILE,
  // o fallback é para tslint não reclamar
  quartileColors['highlighted'], adPrice, olxPrice, percentageFromMedianPrice) : withoutPriceInput;
  return React.createElement(FullWidthFlex, {
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "flex-end",
    marginBottom: "--spacing-1",
    "data-ds-component": "DS-PriceReferenceRuler",
    "aria-labelledby": "abuyPriceRef-price abuyPriceRef-caption"
  }, content);
};